export const MIN_REGISTRATION_AGE = 18;
export const MAX_REGISTRATION_AGE = 60;
export const INITIAL_REGISTRATION_AGE = 22;

export function isValidRegistrationAge(value) {
  const raw = String(value ?? "");
  if (!/^\d+$/.test(raw)) return false;
  const age = Number(raw);
  return age >= MIN_REGISTRATION_AGE && age <= MAX_REGISTRATION_AGE;
}
